import { enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE } from "../../common/Dictionaries";
import { action_updateContractPartieList, action_updateGeneralMessage } from "../../reducers/actions/PAY/actions";
import { deletePolinomio } from "../../services/sPay/partie.service";

export const _handleDeletePolynomyClick = (dispatch, tableItemId, parentType, parentId, contractParties, t) =>{
    deletePolinomio(tableItemId).then((response) => {
        if (response.data.succeeded) {
            if (parentType === enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE.PARTIE) {
                contractParties.forEach(contractPartie => {
                    if (contractPartie.iteM_PARTIDA.id === parentId) {
                        contractPartie = contractPartie.l_POLINOMIO.filter(polinomio => polinomio.id !== tableItemId);
                    }
                });
            } else if (parentType === enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE.SUBPARTIE) {
                contractParties.forEach(subpartie => {
                    if (subpartie.iteM_SUBPARTIDA.id === parentId) {
                        subpartie = subpartie.l_POLINOMIO.filter(polinomio => polinomio.id !== tableItemId);
                    }
                });
            }

            dispatch(action_updateContractPartieList(contractParties));
            dispatch(action_updateGeneralMessage(t('data-lang-msg-operationsucces')));
            return true;
        }
        else {
            dispatch(action_updateGeneralMessage(t('data-lang-msg-operationerror'), true));
            return false
        }
    }).catch(() => {
        dispatch(action_updateGeneralMessage(t('data-lang-msg-operationerror'), true));
        return false;
    });
}